export const LOGIN_SESSION_EXPIRATION_KEY = 'loginSessionExpiration';
export const TOKEN_EXPIRATION_KEY = 'tokenExpiration';
export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refreshToken';
